import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { compose, branch, renderNothing, mapProps, nest, withState, withHandlers } from 'recompose'
import T from 'i18n-react'
import injectSagas from 'helpers/injectSagas'
import styles from './styles.scss'

import Card from './Card'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'
import Divider from 'components/fulcrum/divider/Divider'
import Actions from './Actions'
import SummaryHeader from './SummaryHeader'

import { MODULE_NAME } from './constants'
import sagas from './sagas'

import { segmentSelector  } from 'containers/Project/View/selectors'
import { collapseSelector, projectNvqualStatusSelector, revisionHeadersSelector } from './selectors'
import NvqualDetailsSpec from './NvqualDetailsSpec'
import hideOnAnyRoles from 'containers/Role/Hide/AllGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'
import FileUploadDialog from 'containers/Project/FileUploadDialogNvqual/index'
import {
  fetchNvqualReportInitial,
  toggleCardCollapse,
  initNvqual
} from './actions'
import RevisionDialog from './RevisionDialog'
import { Element } from 'react-scroll'
import Tag from 'components/display/Tag'
import { TAG_COLORS } from 'components/display/Tag/constants'
import { getQueryVariable } from 'helpers/Utils'

const mapStateToProps = state => {
  return {
    projectSegment: segmentSelector(state),
    collapse: collapseSelector(state),
    status: projectNvqualStatusSelector(state),
    revHeaders: revisionHeadersSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onLoadNvqualReport: () => dispatch(fetchNvqualReportInitial()),
    toggleCollapse: () => dispatch(toggleCardCollapse()),
    initNvqual:  () => dispatch(initNvqual())
  }
}

class NvqualCard extends Component {

  constructor(props){
    super(props)
    this.fetchedData = false
  }

  componentWillMount() { 
    this.fetchData()
  }

  componentDidUpdate() { 
    this.fetchData()
  }

  componentDidMount() {
    const queryString = getQueryVariable("action")
    if (queryString === "nvqual_approval") {
      document.getElementById("nvqual_report_anchor").scrollIntoView();
      this.props.toggleRevisionDialog()
    }
  }

  fetchData(){
    const { 
      projectSegment, 
      onLoadNvqualReport, 
      initNvqual
    } = this.props    
    if(['Enterprise', 'Automotive'].includes(projectSegment) && !this.fetchedData){
      this.fetchedData = true
      initNvqual()
      onLoadNvqualReport()
    }
  }

  renderRightOfTitle = () => {
    const { status, revHeaders } = this.props
    const revExists = revHeaders.length != 0
    const text = status ? "Closed" : "Open"
    const color = status ? TAG_COLORS.GREEN : TAG_COLORS.ORANGE
    return (revExists && <Tag color={color} text={text} className={styles.projectStatusTag}/>)
  }

  render() {
    const {
      edit,
      toggleEdit,
      collapse,
      toggleCollapse,
      revisionDialog,
      toggleRevisionDialog,
    } = this.props

    return (
      <React.Fragment>
      <div id="nvqual_report_anchor" />
      <Card>
        <CardHeader title={T.translate('containers.project.nvqualSection.index.header')} rightOfTitle={this.renderRightOfTitle()}>
          <Actions
            collapse={collapse}
            toggleCollapse={toggleCollapse}
            edit={edit}
            toggleEdit={toggleEdit}
            toggleRevisionDialog={toggleRevisionDialog}
          />
        </CardHeader>
        <Divider className={styles.divider}/>
        <SummaryHeader edit={edit}/>
        <NvqualDetailsSpec collapse={collapse}/>
        <FileUploadDialog/>
        <RevisionDialog 
          revisionDialog={revisionDialog}
          toggleRevisionDialog={toggleRevisionDialog}/>
      </Card>
      </React.Fragment>
    )
  }
}

const NvqualSection = nest(Section, NvqualCard)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({[MODULE_NAME]: sagas})
const withModify = compose(
  withState('edit', 'changeEdit', false),
  withHandlers({
    toggleEdit: ({changeEdit}) => () => changeEdit(e => !e)
  })
)
const withRevisionDialogToggle = compose(
  withState('revisionDialog', 'changeRevisionDialog', false),
  withHandlers({
    toggleRevisionDialog: ({changeRevisionDialog}) => () => changeRevisionDialog(e => !e)
  })
)
const withRoles = compose(
  mapProps(
    (props) => ({
      ...props,
      roles: [
        GLOBAL_ROLES.CLIENT_ACCESS,
      ]
    })
  ),
  hideOnAnyRoles,
)

const enhance = compose(
  withRoles,
  withSagas,
  withConnect,
  withModify,
  withRevisionDialogToggle,
  branch(
    ({ projectSegment }) => !['Enterprise', 'Automotive'].includes(projectSegment),
    renderNothing
  )
)

export default enhance(NvqualSection)
